export default __webpack_public_path__ + "static/media/milestone 250.12d32565.svg";